<template>
    <component
            :is="tag"
            class="fade-element"
            :class="{'visible': visible}"
    >
        <slot></slot>
    </component>
</template>

<script>
    import {EventBus} from '../../utils/EventBus'
    import inViewport from 'vue-in-viewport-mixin'
    import _extend from 'lodash/extend'

    const fromOptions = { y:200, opacity: 0, force3D:false };
    const toOptions = { y: 0, opacity:1, delay:0.35, force3D:false };

    export default {
        name: 'FadeAnimation',
        mixins: [inViewport],
        props: {
            inViewportOffset: {
                type: Number,
                default: -200,
            },
            from: Object,
            to: Object,
            tag: {
                type: String,
                default: 'div',
            },
            time: {
                type: Number,
                default: 1
            },
        },
        data() {
            return {
                visible: false,
                isAbove: false,
                isBelow: false,
                loaded: false
            }
        },
        computed: {
            el() {
                return $(this.$el);
            }
        },
        methods: {
            fromOptions() {
                return this.from || fromOptions;
            },
            toOptions() {
                return this.to || toOptions;
            }
        },
        watch: {
            'inViewport.now': function (visible) {
                if (!this.above && visible && !this.visible && EventBus.pageLoaded) {
                    this.visible = visible;

                    _extend(this.toOptions(), {onComplete: ()=> {
                        this.$emit('complete');
                    }});
                    TweenMax.fromTo(this.el, this.time, this.fromOptions(), this.toOptions());
                }
            },
            'inViewport.fully': function (isFullVisible) {

            },
            'inViewport.above': function (above) {
                this.above = above;
            },
            'inViewport.below': function (below) {
                this.isBelow = below;
            }
        },

    }
</script>

<style lang="scss" type="text/scss">

    .fade-element {
        display: inline-block;
        position: relative;
        overflow: hidden;
        opacity: 0;
        z-index: 1;

        &.no-overflow {
            overflow: visible;
        }

        &.full-width {
            width: 100%;
            height: 100%;
        }
    }

</style>